"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var extractPathFromURL_exports = {};
__export(extractPathFromURL_exports, {
  extractPathFromURL: () => extractPathFromURL
});
module.exports = __toCommonJS(extractPathFromURL_exports);
function extractExactPathFromURL(url) {
  if (
    // If a universal link / app link / web URL is used, we should use the path
    // from the URL, while stripping the origin.
    url.match(/^https?:\/\//)
  ) {
    var { origin, href } = new URL(url);
    return href.replace(origin, "");
  }
  return fromDeepLink(url);
}
function fromDeepLink(url) {
  var res;
  try {
    res = new URL(url);
  } catch (unused) {
    if (url.startsWith("/")) {
      return url;
    }
    return url.replace(/^[^:]+:\/\//, "");
  }
  var results = "";
  if (res.host) {
    results += res.host;
  }
  if (res.pathname) {
    results += res.pathname;
  }
  var qs = !res.search ? "" : (
    // @ts-ignore: `entries` is not on `URLSearchParams` in some typechecks.
    [
      ...res.searchParams.entries()
    ].map(function(param) {
      var [k, v] = param;
      return `${k}=${decodeURIComponent(v)}`;
    }).join("&")
  );
  if (qs) {
    results += "?" + qs;
  }
  return results;
}
function extractPathFromURL(_prefixes) {
  var url = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  var pathFromPrefix = extractPathFromPrefix(_prefixes, url);
  if (pathFromPrefix !== void 0) {
    return pathFromPrefix.replace(/^\//, "");
  }
  return extractExactPathFromURL(url).replace(/^\//, "");
}
function extractPathFromPrefix() {
  var prefixes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], url = arguments.length > 1 ? arguments[1] : void 0;
  var prefix = getMatchingPrefix(prefixes, url);
  if (!prefix) return void 0;
  return url.slice(prefix.length);
}
var PREFIX_BOUNDARY_CHARS = [
  "/",
  "?",
  "#"
];
function getMatchingPrefix(prefixes, url) {
  return prefixes.filter(function(prefix) {
    return matchesPrefix(prefix, url);
  }).sort(function(a, b) {
    return b.length - a.length;
  })[0];
}
function matchesPrefix(prefix, url) {
  if (!url.startsWith(prefix)) return false;
  if (url.length === prefix.length) return true;
  if (prefix.endsWith("/")) return true;
  return PREFIX_BOUNDARY_CHARS.includes(url[prefix.length]);
}
//# sourceMappingURL=extractPathFromURL.js.map
